import React from 'react';
import { Radio } from 'antd';

const SbRadio = ({ value, checked, onChange, disabled, ...rest }) => {
  return (
    <Radio
      value={value}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    />
  );
};

export default SbRadio;
